<div class="container-fluid maap-root-container">
    <app-header
               [deId]="deId"
               [dissableDeIdSwitch]="dissableDeIdSwitch"
               (deIdChange)="updateDeIdMode($event)">
    </app-header>
    <app-sidebar [deId]="deId"
                 [dissableDeIdSwitch]="dissableDeIdSwitch"
                 (deIdChange)="updateDeIdMode($event)">
    </app-sidebar>
    <div style="margin-top: 60px; margin-left: 80px;">
        <header class="standalone-page-header px-3 pt-4">
            <h1 class="standalone-page-title">{{appHeaderTitle}}</h1>
        </header>
        <router-outlet></router-outlet>
    </div>
</div>
